import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { BaseService } from './base.service';

@Injectable({
  providedIn: 'root'
})
export class ManagedStoreService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.stores;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public userManagedStoreList(criteria): Observable<any> {
    const url = this.getFullUrl(this.envService.userStore);
    // const params = this.getParams(criteria, true);

    return this.http.post<any>(url, criteria, { headers: this.headers, observe: 'response' }).pipe(
      map((res) => {
        if (res && res.body.content) {
          res.body.content.map((val) => {
            if (val.storeCode && val.name) {
              val.storeNameToDisplay = `${val.storeCode}-${val.name}`;
            }
          });
        }

        return res.body;
      })
    );
  }
}
